import { useIntl } from "@edx/frontend-platform/i18n";

import { ExclamationMarkSVG } from "../assets/svgs";
import messages from "./messages";

const RequiredRemark = ({ showAsError }) => {
    const { formatMessage } = useIntl();

    return(
        <span>
            <span 
                className="mr-1"
                style={{color: showAsError ? "#b20610" : "initial", fontSize: 14}}
            >
                ({formatMessage(messages['register.required.remark'])})
            </span> 
            {showAsError && <ExclamationMarkSVG color="#b20610" width={6} height={12} />}
        </span>
    )
}

export default RequiredRemark;